import * as Yup from "yup";
import { ExpenseTag } from "@quantizr-engineering/common/types/show";

export const expenseValidationSchema = Yup.object().shape({
  id: Yup.number().nullable(),
  createdAt: Yup.date().nullable(),
  updatedAt: Yup.date().nullable(),
  name: Yup.string().required("Expense name is required"),
  cost: Yup.number()
    .required("Cost is required")
    .typeError("Cost must be a number"),
  quantity: Yup.number()
    .default(1)
    .min(0, "Quantity must be positive")
    .typeError("Quantity must be a number"),
  isActual: Yup.boolean().default(false),
  isVenueExpense: Yup.boolean().default(false),
  actualCost: Yup.number().nullable().typeError("Actual cost must be a number"),
  date: Yup.date().nullable(),
  notes: Yup.string().nullable().max(250, "250 chars or less"),
  tag: Yup.string()
    .required("Expense tag is required")
    .oneOf(Object.values(ExpenseTag), "Invalid expense tag"),
  show: Yup.mixed().nullable(),
  run: Yup.mixed().nullable(),
  recording: Yup.mixed().nullable(),
  release: Yup.mixed().nullable(),
  composition: Yup.mixed().nullable(),
});
